////////LIBRARY/////////
import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import _, { map, find, includes, isEqual } from 'lodash'
import { useSelector } from 'react-redux'

/////////STYLED/////////
const TabsNavigationsWrapper = styled.div``
const TabsNavHeader = styled.div`
	display: grid;
	grid-auto-columns: max-content;
	grid-column-gap: 10px;
	grid-template-rows: 34px;
`
const TableHeaderCard = styled(Link)`
	text-decoration: none;
	display: ${(props) => (props.hidingSiblings ? 'none' : 'flex')};
	padding: 0px 10px;
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	border-bottom: ${(props) => (props.isactive === 'true' ? 'none' : 'null')};
	color: ${(props) => (props.isactive === 'true' ? props.theme.colors.primary : props.theme.colors.tabText)};
	border-radius: 4px 4px 0 0;
	margin-bottom: -1px;
	z-index: 1;
	background-color: ${(props) => (props.isactive === 'true' ? props.theme.background.tab : props.theme.colors.table.header.main)};
	cursor: pointer;
	grid-row-start: 1;
	grid-row-end: 1;
	font-weight: bold;
	line-height: 34px;
`
const TabsNavBody = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	padding: 20px;
	background-color: ${(props) => props.theme.background.tab};
`
/////////STYLED/////////

const TabsNavigations = (props) => {
	const { user } = useSelector((state) => ({
		user: state.user,
	}))

	const location = useLocation()

	props.setBackPage(!!props.parentObj.backPage)

	const [hidingSiblings, setHidingSiblings] = useState(false)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TabsNavigationsWrapper>
			<TabsNavHeader>
				{map(props.parentObj.routes, (route, id) => {
					let matchedUrl = false
					if (includes(location.pathname, `${props.parentObj.pathName}${route.pathName}`)) matchedUrl = true
					if (route.hidingSiblings && !hidingSiblings) setHidingSiblings(true)
					// Is user didn't have right, we don't generate tab
					let authorized = false
					// Auth can contain multiples values, so we need to check if it is array
					if (_.isArray(route.auth)) {
						map(route.auth, (auth) => {
							const f = find(user.identity.rolePrivileges.privileges, (o) => o.label === auth) ? true : false
							if (f) authorized = true
						})
					} else {
						authorized = find(user.identity.rolePrivileges.privileges, (o) => o.label === route.auth) ? true : false
					}

					if (location.pathname.includes(route.pathName.toString())) {
						props.setBackPage(!!route.backPage)
					}

					// If location has an ID, and the next tab link contains ID to replace,
					// We need to do this test to keep this ID in navigation
					let tabLink
					if (route.path.includes(':id')) {
						tabLink = `${!isEqual(props.firstParent, {}) ? props.firstParent.path : ''}${props.parentObj.path}${route.path}`
						const ar = location.pathname.split('/')
						tabLink = tabLink.replace(':id', _.last(ar))
					} else if (route.hasAltPath && route.altPath.includes(':id') && props.usingAltPath) {
						tabLink = `${!isEqual(props.firstParent, {}) ? props.firstParent.path : ''}${props.parentObj.path}${route.altPath}`
						const ar = location.pathname.split('/')
						tabLink = tabLink.replace(':id', _.last(ar))
					} else {
						tabLink = `${!isEqual(props.firstParent, {}) ? props.firstParent.path : ''}${props.parentObj.path}${route.path}`
					}

					return authorized ? (
						<TableHeaderCard
							key={id}
							to={tabLink}
							isactive={
								/*queryParam.id
										? ( location.pathname === `${ props.routes.pathName }${ route.pathName }/${ queryParam.id }` ).toString()
										: ( location.pathname === `${ props.routes.pathName }${ route.pathName }` ).toString()*/
								includes(location.pathname, `${props.parentObj.pathName}${route.pathName}`).toString()
							}
							hidingSiblings={hidingSiblings && !matchedUrl}
						>
							{props.translations[route.tabName] || route.tabName}
						</TableHeaderCard>
					) : null
				})}
			</TabsNavHeader>
			<TabsNavBody>{props.children}</TabsNavBody>
		</TabsNavigationsWrapper>
	)
}

TabsNavigations.propTypes = {}

TabsNavigations.defaultPropTypes = {}

export default TabsNavigations
